import string from '@mgo/core/src/validations/stringValidator';

const DPO_STATES = new Set(['AA', 'AE', 'AP']);

export const isPhoneOptionalAddress = ({ city = '', state = '', zipCode = '' } = {}) => {
  const normalizedCity = `${city || ''}`.trim().toUpperCase();
  const normalizedState = `${state || ''}`.trim().toUpperCase();
  const normalizedZipCode = `${zipCode || ''}`.trim().substring(0, 5);

  return normalizedZipCode === '20189'
    || (normalizedCity === 'DPO' && DPO_STATES.has(normalizedState));
};

export const phoneNumber = string()
  .label('Phone Number')
  .transform((value) => (!value ? '' : value))
  .test(
    'phoneNumberRequiredOrFormatted',
    'Please enter a phone number.',
    function validatePhoneNumber(value) {
      if (!value) return Boolean(this.options.context?.phoneNumberOptional);
      return value.length === 10;
    },
  );
